import collapseDirective from 'Site/directive/collapse';
import store from 'Site/js/store';
import SelectFriends from 'Site/component/SelectFriends.vue';
import Vue from 'vue';

export default function () {

    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        components: {
            SelectFriends
        },
        data() {
            return {
                actionUrl: '',
                profile: null
            };
        },
        directives: {
            collapse: collapseDirective
        },
        methods: {
            setUser(users) {
                this.profile = users[0].id;
            },
            submit() {
                const user = document.querySelector('#user').value;
                if (!user) {
                    window.location.href = store.state.config.endpoints.notes;
                    return;
                }
                window.location.href = store.state.config.endpoints.notesUser.replace(':user', user);
            },
            updateAction(action, confirmMessage) {
                this.actionUrl = action;
                if (confirmMessage) {
                    this.$store.dispatch('showConfirm', {
                        text: confirmMessage,
                        callback: () => {
                            document.querySelector('#profile-notes-form').submit();
                        }
                    });
                } else {
                    document.querySelector('#profile-notes-form').submit();
                }
            }
        },
        mounted() {
            this.profile = this.$store.state.config.data.user;
        },
        store
    });
}
